/**
 * Cencora Gilroy Font Loader for jsPDF
 * 
 * This module registers the Cencora-Gilroy font family with jsPDF.
 */

// Import the base64-encoded TTF fonts
import { Cencora_Gilroy_Regular_base64 } from './fonts/Cencora-Gilroy-Regular';
import { Cencora_Gilroy_Bold_base64 } from './fonts/Cencora-Gilroy-Bold';
import { Cencora_Gilroy_Medium_base64 } from './fonts/Cencora-Gilroy-Medium';

/**
 * Registers Cencora-Gilroy fonts with a jsPDF instance
 * @param {jsPDF} doc - The jsPDF document instance
 * @returns {boolean} - True if custom fonts were registered, false if using fallback
 */
export function registerCencoraFonts(doc) {
    try {
        doc.addFileToVFS('Cencora-Gilroy-Regular.ttf', Cencora_Gilroy_Regular_base64);
        doc.addFont('Cencora-Gilroy-Regular.ttf', 'CencoraGilroy', 'normal');
        
        doc.addFileToVFS('Cencora-Gilroy-Bold.ttf', Cencora_Gilroy_Bold_base64);
        doc.addFont('Cencora-Gilroy-Bold.ttf', 'CencoraGilroy', 'bold');
        
        doc.addFileToVFS('Cencora-Gilroy-Medium.ttf', Cencora_Gilroy_Medium_base64);
        doc.addFont('Cencora-Gilroy-Medium.ttf', 'CencoraGilroy', 'normal', 500);
        
        return true;
    } catch (e) {
        console.warn('Failed to register Cencora fonts, using fallback:', e);
        return false;
    }
}

/**
 * Font family name to use with doc.setFont()
 */
export const CENCORA_FONT_FAMILY = 'CencoraGilroy';

/**
 * Example usage in pdfExport.js:
 * 
 * import { registerCencoraFonts, CENCORA_FONT_FAMILY } from './fontLoader';
 * 
 * const doc = new jsPDF();
 * registerCencoraFonts(doc);
 * 
 * doc.setFont(CENCORA_FONT_FAMILY, 'normal');  // Regular
 * doc.setFont(CENCORA_FONT_FAMILY, 'bold');    // Bold
 */
